import React from "react";
import { Button, Menu, Dropdown, Modal, Table, Input } from "antd";
import {
  EllipsisOutlined,
  LeftCircleFilled,
  RightCircleFilled,
  DashboardOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Modal as CustomModal } from "components/General/ModalFormComponents";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import RenameDeletePopup from "helperComponents/RenameDeletePopup";
import i18n from "i18next";

const CustomMenu = ({ onClick }) => (
  <Menu className={styles.menu} onClick={onClick}>
    <Menu.Item key="updateQuota">{i18n.t("settings.164")}</Menu.Item>
    <Menu.Item key="rename">{i18n.t("settings.165")}</Menu.Item>
    <Menu.Item key="invite">{i18n.t("settings.166")}</Menu.Item>
    <Menu.Item key="delete">{i18n.t("settings.167")}</Menu.Item>
    <Menu.Item key="dashboardAccess">{i18n.t("settings.221")}</Menu.Item>
  </Menu>
);

const Representation = ({
  showNewOrganization,
  setShowNewOrganization,
  user,
  organizations,
  onHeaderMenuClick,
  closeNewOrganizationView,
  createOrganization,
  newTeamName,
  setNewTeamName,
  creatingTeam,
  updateQuotaModal,
  setUpdateQuotaModal,
  updateQuota,
  quota,
  setQuota,
  isMobile,
  unassignedDashboards,
  setShowRenameTeam,
  showRenameTeam,
  renameTeam,
  setTeamName,
  teamName,
  disableBtn,
  showDeleteTeam,
  setShowDeleteTeam,
  deleteOrganization,
  teamDashboards,
  setTeamDashboards,
  teamForInfo,
  setTeamForInfo,
}) => {
  const theme = useSelector((state) => state.DashboardReducer.theme);

  const cols = [
    {
      title: <span className={styles.idColumn}>ID</span>,
      dataIndex: "id",
      key: "id",
      align: "center",
      className: `${styles.idColumn}`,
    },
    {
      title: <span className={styles.nameColumn}>Dashboard Name</span>,
      dataIndex: "name",
      key: "name",
      align: "left",
      className: `${styles.nameColumn}`,
    },
  ];
  const tableData = Object.keys(teamDashboards || {})?.map((key) => ({
    key: key,
    id: key,
    name: teamDashboards[key],
  }));
  const ModalStyle = {
    padding: "30px 45px",
    borderRadius: "14px",
    overflow: "hidden",
  };
  const modalBg = theme === "dark" ? "#1e1e2e" : "#ffffff";
  const modalTextColor = theme === "dark" ? "#e0e0e0" : "#1a1a2e";

  return (
    <>
        <div className={styles.wrapper}>
          <div className={styles.pageHead}>
            <div>
              <h2 className={styles.containerTitle}>{i18n.t("settings.168")}</h2>
              <p className={styles.subtitle}>{i18n.t("settings.169")}</p>
            </div>
            <div className={styles.btnWrapper}>
              <DashboardOutlined style={{ fontSize: "18px" }} />{" "}
              {i18n.t("settings.170")} {unassignedDashboards}
              <Button
                className={styles.btn}
                onClick={() => setShowNewOrganization(true)}
                icon={<PlusOutlined />}
              >
                {i18n.t("settings.171")}
              </Button>
            </div>
          </div>
          <div className={styles.content}>
            {organizations.map((obj, index) => (
              <div className={styles.card} key={index}>
                <h3 className={styles.cardTitle}>
                  {obj.OrganizationName}
                  <Dropdown
                    overlay={() => (
                      <CustomMenu
                        onClick={(e) =>
                          onHeaderMenuClick(
                            e.key,
                            obj.OrganizationID,
                            obj.OrganizationName
                          )
                        }
                      />
                    )}
                    trigger={["click"]}
                  >
                    <EllipsisOutlined
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                      }}
                    />
                  </Dropdown>
                </h3>
                {isMobile ? (
                  <>
                    <div className={styles.mobileRow}>
                      <div
                        className={`${styles.permitted} ${styles.textAlignLeft}`}
                      >
                        {i18n.t("settings.172")}
                      </div>
                      <div className={styles.permitted}>
                        {obj.OrganizationPermittedDashboards}
                      </div>
                    </div>
                    <div className={styles.mobileRow}>
                      <div
                        className={`${styles.active} ${styles.textAlignLeft}`}
                      >
                        {i18n.t("settings.173")}
                      </div>
                      <div className={styles.active}>
                        {obj.ActiveDashboards}
                      </div>
                    </div>
                    <div className={styles.mobileRow}>
                      <div
                        className={`${styles.write} ${styles.textAlignLeft}`}
                      >
                        {i18n.t("settings.174")}
                      </div>
                      <div className={styles.write}>{obj.ReadWriteMembers}</div>
                    </div>
                    <div className={styles.mobileRow}>
                      <div className={`${styles.read} ${styles.textAlignLeft}`}>
                        {i18n.t("settings.175")}
                      </div>
                      <div className={styles.read}>{obj.ReadMembers}</div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.cardHeader}>
                      <div className={styles.permitted}>
                        {i18n.t("settings.172")}
                      </div>
                      <div className={styles.active}>
                        {i18n.t("settings.173")}
                      </div>
                      <div className={styles.write}>
                        {i18n.t("settings.174")}
                      </div>
                      <div className={styles.read}>
                        {i18n.t("settings.175")}
                      </div>
                    </div>
                    <div className={styles.cardContent}>
                      <div className={styles.permitted}>
                        {obj.OrganizationPermittedDashboards}
                      </div>
                      <div className={styles.active}>
                        {obj.ActiveDashboards}
                      </div>
                      <div className={styles.write}>{obj.ReadWriteMembers}</div>
                      <div className={styles.read}>{obj.ReadMembers}</div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          <Modal
            open={updateQuotaModal}
            bodyStyle={ModalStyle}
            footer={null}
            onCancel={() => {
              setQuota(20);
              setUpdateQuotaModal(null);
            }}
            style={{ overflow: "hidden", borderRadius: "15px", padding: "0px" }}
          >
            <p className={styles.modalTitle}>{i18n.t("settings.164")}</p>
            <div className={styles.row}>
              <p className={styles.modalText}>{i18n.t("settings.172")}:</p>
              <LeftCircleFilled
                style={{ fontSize: "16px" }}
                onClick={() => setQuota(quota - 1)}
              />
              {quota}
              <RightCircleFilled
                style={{ fontSize: "16px" }}
                onClick={() => setQuota(quota + 1)}
              />
            </div>
            <div className={styles.row}>
              <Button
                className={`${styles.modalBtn} ${styles.transparent}`}
                onClick={() => {
                  setQuota(5);
                  setUpdateQuotaModal(null);
                }}
              >
                {i18n.t("button.3")}
              </Button>
              <Button
                className={`${styles.modalBtn} ${styles.red}`}
                onClick={() => updateQuota()}
              >
                {i18n.t("button.30")}
              </Button>
            </div>
          </Modal>

          {showRenameTeam && (
            <RenameDeletePopup
              text={teamName}
              setText={setTeamName}
              label={i18n.t("settings.165")}
              handleAction={renameTeam}
              closePopup={setShowRenameTeam}
              disableBtn={disableBtn}
              type="rename"
            />
          )}
          {showDeleteTeam && (
            <RenameDeletePopup
              label={i18n.t("settings.167")}
              handleAction={deleteOrganization}
              closePopup={setShowDeleteTeam}
              disableBtn={disableBtn}
              type="delete"
            />
          )}
          {teamDashboards && Object.keys(teamDashboards).length > 0 && (
            <CustomModal
              title={
                <span>
                  The team <b>{teamForInfo}</b> have access to Dashboards
                </span>
              }
              titleAsset={""}
              description={`Total dashboards: ${
                Object.keys(teamDashboards).length
              }`}
              showModal={Object.keys(teamDashboards).length > 0}
              widthofmodal={window.innerWidth > 500 ? "550px" : "350px"}
              onClose={() => {
                setTeamDashboards(null);
                setTeamForInfo(null);
              }}
            >
              <div className={styles.dashboardsWrapper}>
                <Table
                  columns={cols}
                  dataSource={tableData}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "30"],
                  }}
                />
              </div>
            </CustomModal>
          )}
        </div>

      {/* ── New Team Modal ── */}
      <Modal
        open={showNewOrganization}
        onCancel={closeNewOrganizationView}
        footer={null}
        centered
        width={480}
        styles={{
          content: {
            background: modalBg,
            borderRadius: "14px",
            border: "1px solid var(--line)",
            padding: "28px 32px",
          },
        }}
      >
        <div style={{ color: modalTextColor }}>
          <h3 style={{ margin: "0 0 6px", fontSize: "17px", fontWeight: 600, color: modalTextColor }}>
            {i18n.t("settings.171")}
          </h3>
          <p style={{ margin: "0 0 20px", fontSize: "13px", color: "var(--color4)", lineHeight: 1.6 }}>
            {i18n.t("settings.177")}
          </p>
          <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "var(--color4)", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
            {i18n.t("settings.179")}
          </label>
          <Input
            placeholder={i18n.t("settings.180")}
            value={newTeamName}
            onChange={(e) => setNewTeamName(e.target.value)}
            onPressEnter={createOrganization}
            autoFocus
            style={{
              borderRadius: "8px",
              background: "transparent",
              borderColor: "var(--line)",
              color: modalTextColor,
              height: "40px",
              marginBottom: "24px",
            }}
          />
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button
              onClick={closeNewOrganizationView}
              style={{
                padding: "8px 18px",
                background: "transparent",
                border: "1px solid var(--line)",
                borderRadius: "8px",
                color: modalTextColor,
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              {i18n.t("button.3")}
            </button>
            <button
              onClick={createOrganization}
              disabled={creatingTeam}
              style={{
                padding: "8px 22px",
                background: "var(--active)",
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                opacity: creatingTeam ? 0.7 : 1,
              }}
            >
              {creatingTeam ? "Creating..." : i18n.t("settings.181")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Representation;
